import React, { memo } from "react";
import CategoriaCard from "../CategoriaCard";
import { esImagenValida } from "../../utils/imagenes";

function CategoriasTienda({
  listaDeSecciones = [],
  menuAgrupadoPorSeccion = {},
  categoriaAnimadaIndex = 0,
  onIrASeccion,
}) {
  if (!listaDeSecciones.length) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "16px 0 16px 16px",
        borderBottom: "1px solid #eef",
      }}
    >
      <span
        style={{
          fontSize: "11px",
          fontWeight: "800",
          color: "#888",
          display: "block",
          marginBottom: "12px",
          letterSpacing: "0.5px",
        }}
      >
        NAVEGAR POR CATEGORÍAS
      </span>

      <div
        style={{
          display: "flex",
          gap: "16px",
          overflowX: "auto",
          paddingRight: "16px",
          scrollbarWidth: "none",
        }}
      >
        {listaDeSecciones.map((sec, index) => {
          const productoConImagen = menuAgrupadoPorSeccion[sec]?.find((p) =>
            esImagenValida(p.imagen),
          );

          const fotoPortada = productoConImagen?.imagen || "";

          return (
            <div
              key={sec}
              style={{
                transform:
                  categoriaAnimadaIndex === index ? "scale(1.17)" : "scale(1)",
                transition: "transform 0.35s ease, filter 0.35s ease",
                filter:
                  categoriaAnimadaIndex === index
                    ? "drop-shadow(0 8px 14px rgba(0,0,0,0.14))"
                    : "none",
                transformOrigin: "center",
              }}
            >
              <CategoriaCard
                sec={sec}
                fotoPortada={fotoPortada}
                onClick={() => onIrASeccion(sec)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default memo(CategoriasTienda);
